import { Fragment } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import AuthLayout from '../components/layout/auth';

//import UserLayout from '../components/layout/admin';
import Register from '../components/auth/register';
import RegisterOtp from '../components/auth/register-otp';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Login from '../components/auth/login';
import LoginOtp from '../components/auth/login-otp';
import PageNotFound from '../components/pagenotfound';
import Home from '../components/home';

import DashboardLayout from '../components/layout/dashboard';
import Notifications from '../components/dashboard/notifications';


import Profile from '../components/dashboard/profile/main';
import ProfileName from '../components/dashboard/profile/name';
import ProfileFilingStatus from '../components/dashboard/profile/filing-status';
import ProfileNoOfDependents from '../components/dashboard/profile/no-of-dependents';
import ProfileEmail from '../components/dashboard/profile/email';
import ProfilePrivacyPolicy from '../components/dashboard/profile/privacy-policy';
import ProfileTermsAndConditions from '../components/dashboard/profile/terms-and-conditions';
import ProfileFeedback from '../components/dashboard/profile/feedback';
import ProfileRemoveAccount from '../components/dashboard/profile/remove-account';

import Calculate from '../components/dashboard/calculate/main';
import CalculateDetails from '../components/dashboard/calculate/details';
import ContractList from '../components/dashboard/contract/list';
import ContractEdit from '../components/dashboard/contract/main';
import ContractDetails from '../components/dashboard/contract/details';

import Records from '../components/dashboard/records/list';
import RecordAddStep1 from '../components/dashboard/records/add-step-1';
import RecordAddStep2 from '../components/dashboard/records/add-step-2';
import RecordAddLicense from '../components/dashboard/records/add-license';
import RecordAddCertification from '../components/dashboard/records/add-certification';
import RecordAddVaccine from '../components/dashboard/records/add-vaccine';
import Record from '../components/dashboard/records/details';
import ShiftNew from '../components/dashboard/shift/shift-new';



const AllRoutes = () => {
    return (
        <Fragment>
            <BrowserRouter>
                <Routes>
                    <Route path="/" exact element={<Home />} />

                    <Route element={<AuthLayout />}>
                        <Route path="/"   >
                            <Route path="register" element={<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                                <Register /></GoogleOAuthProvider>} />

                               
                            <Route path="register-otp" element={<RegisterOtp />} />

                            <Route path="login" element={<Login />} />
                            <Route path="login-otp" element={<LoginOtp />} />

                        </Route>
                    </Route>

                    <Route element={<DashboardLayout />}>
                        <Route path="/"   >

                            <Route path="profile" element={<Profile />} />
                            <Route path="profile"   >

                                <Route path="name" element={<ProfileName />} />
                                <Route path="filing-status" element={<ProfileFilingStatus />} />
                                <Route path="no-of-dependents" element={<ProfileNoOfDependents />} />
                                <Route path="email" element={<ProfileEmail />} />
                                <Route path="privacy-policy" element={<ProfilePrivacyPolicy />} />
                                <Route path="terms-and-conditions" element={<ProfileTermsAndConditions />} />
                                <Route path="feedback" element={<ProfileFeedback />} />
                                <Route path="remove-account" element={<ProfileRemoveAccount />} />

                            </Route>
                            <Route path="calculate" element={<Calculate />} />
                            <Route path="calculate"   >
                                <Route path="details" element={<CalculateDetails />} />
                            </Route>

                            <Route path="contract"   >
                                <Route path="list" element={<ContractList />} />
                                <Route path="edit/:contract_id" element={<ContractEdit />} />
                                <Route path="details/:contract_id" element={<ContractDetails />} />
                            </Route>
                          
                            <Route path="records" element={<Records />} />
                            <Route path="records"   >
                           
                               <Route path="record-add-step-1" element={<RecordAddStep1 />} />
                               <Route path="record-add-step-2/:category" element={<RecordAddStep2 />} />
                               <Route path="record-add-license" element={<RecordAddLicense />} />
                               <Route path="record-add-certification" element={<RecordAddCertification />} />
                               <Route path="record-add-vaccine" element={<RecordAddVaccine />} />
                               <Route path="record/:record_id" element={<Record />} />

                            </Route>


                            <Route path="shifts" element={<ShiftNew />} />

                            <Route path="notifications" element={<Notifications />} />

                        </Route>

                    </Route>







                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </BrowserRouter>
        </Fragment>
    );

};

export default AllRoutes;
